import { brokerApi } from './brokerClient'

export type ConnectorEnvironment = 'DEV' | 'QA' | 'HML' | 'PRD'
export type ConnectorStatus = 'pending' | 'active' | 'revoked'

export interface ConnectorItem {
  id: number
  tenant_id: number
  environment: ConnectorEnvironment
  cert_fingerprint: string
  status: ConnectorStatus
  last_seen_at: string | null
  online: boolean
  last_heartbeat_age_seconds: number | null
}

export interface CreateConnectorPayload {
  tenant_id: number
  environment: ConnectorEnvironment
  validity_days?: number
}

export interface CreateConnectorResponse {
  cert_pem: string
  key_pem: string
  fingerprint: string
  expires_at: string
  tenant_id: number
  environment: string
  docker_compose_yaml: string
}

export interface RevokeConnectorPayload {
  reason: string
}

export interface RenewConnectorPayload {
  validity_days?: number
}

export interface RenewConnectorResponse {
  cert_pem: string
  key_pem: string
  fingerprint: string
  expires_at: string
  tenant_id: number
  environment: string
}

export const connectorsApi = {
  list: async (): Promise<ConnectorItem[]> => {
    const r = await brokerApi.get<{ connectors: ConnectorItem[] }>(
      '/_broker/api/admin/connectors',
    )
    return r.data.connectors
  },

  create: async (
    payload: CreateConnectorPayload,
  ): Promise<CreateConnectorResponse> => {
    const r = await brokerApi.post<CreateConnectorResponse>(
      '/_broker/api/admin/connectors',
      payload,
    )
    return r.data
  },

  revoke: async (
    fingerprint: string,
    payload: RevokeConnectorPayload,
  ): Promise<void> => {
    await brokerApi.delete(`/_broker/api/admin/connectors/${fingerprint}`, {
      data: payload,
    })
  },

  renew: async (
    fingerprint: string,
    payload: RenewConnectorPayload = {},
  ): Promise<RenewConnectorResponse> => {
    const r = await brokerApi.post<RenewConnectorResponse>(
      `/_broker/api/admin/connectors/${fingerprint}/renew`,
      payload,
    )
    return r.data
  },
}
